import React, { useEffect, useState } from "react";
import { Card, Spin, Tag, Popover, Divider, Rate, Tooltip, Progress, Checkbox } from "antd";
import { momentit, replaceContentEditableText } from "../../utils";
import { useDispatch, useSelector } from "react-redux";
import { MoreOutlined } from "@ant-design/icons";
import {
 getAnswerRatingForCM,
 getInlineImage,
 updateCurationStatus,
 expertAnswerQuestion
} from "../../API/api";
// import { Modal } from "react-bootstrap";
import { bindActionCreators } from "redux";
import { Actions } from "../../Action";
import AttachmentBox from "../AttachmentBox/AttachmentBox";
import moment from "moment";
import { toast } from "react-toastify";
import { SyncOutlined } from "@ant-design/icons";
import ReactQuill, { Quill } from "react-quill";
import "react-quill/dist/quill.snow.css";
import ImageResize from "quill-image-resize-module-react";
import { CloseCircleOutlined } from "@ant-design/icons";
import Rating from '@mui/material/Rating';
import styles from './ExpertRecordsDetailStyles.module.css';
// import { ReactComponent as CuratedSync } from '../../Icons/check-verified-02.svg'
import InternalIcon from '../../Icons/internal.svg'
import TooltipComp from "../../NewComponent/ToolTip/TooltipComp";
import { Modal, ModalHeader } from "react-bootstrap";
import { ReactComponent as ViewIcon } from "../../Icons/totalView.svg";




const modalTitleStyle = {
  color: "rgb(42, 54, 74)",
  fontSize: "20px",
  fontFamily: "Helvetica",
};
export default function Answercard({ answer, isLoading, reload }) {
 const [data, setData] = useState(answer);
 const [rating, setRating] = useState(0);
 const [allRating, setAllRating] = useState(null);
 const [isModal, setModal] = useState(false);
 const [isCurated, setCurated] = useState(
   data.curationStatus === "curated" ? true : false
 );
 const [inline, setInline] = useState([]);
 const [isRecent, setRecent] = useState(false);
 const [isLoad, setLoad] = useState(false);
 const [isEdit, setEdit] = useState(false);
 const [isPlay, setPlay] = useState(false);
 const [updateData, setUpdateData] = useState({
   text: data.answer,
   privacy: data.privacy,
   internal: data.internal,
   attachment: data.attachments,
 });
 const dispatch = useDispatch();
 const expertRecordsState = useSelector(state => state.expertRecord);
 const state = useSelector((state) => state.expertRecord.clickedData);
 const { advanceFilterModalToggle, cmrSelectedDataDetailed, cmrIsGoBack } =
   bindActionCreators(Actions, dispatch);
 const fetchRating = () => {
   if (data.inlineImages.length > 0) {
     getInlineImage(data.inlineImages).then((res) => {
       if (res === undefined) return;
       if (res.data.success) {
         setInline(res.data.data);
       }
     });
   }
   if (data.answerStatus === "answered") {
     getAnswerRatingForCM("answerids", answer.answerUuid).then((res) => {
       if (res === undefined) return;
       setAllRating(res.data.data[answer.answerUuid]);
       setRating(
         res.data.data[answer.answerUuid].rating === null
           ? res.data.data[answer.answerUuid].overallRating
           : res.data.data[answer.answerUuid].rating
       );
     });
   }
 };
 const modules = {
   toolbar: [
     ["bold", "italic", "underline", "strike", "blockquote"],
     [{ list: "ordered" }, { list: "bullet" }],
     ["link", "image"],
   ],
   clipboard: {
     matchVisual: false,
   },
   imageResize: {
     parchment: Quill.import("parchment"),
     modules: ["Resize", "DisplaySize"],
   },
 };
 const formats = [
   "bold",
   "italic",
   "underline",
   "strike",
   "blockquote",
   "list",
   "bullet",
   "link",
   "image",
 ];
 const getBase64 = (file, cb) => {
   let reader = new FileReader();
   reader.readAsDataURL(file);
   reader.onload = function () {
     cb(reader.result);
   };
   reader.onerror = function (error) { };
 };
 const attachmentsData = (file) => {
   getBase64(file, (result) => {
     var size =
       file.size / (1024 * 1024) > 1
         ? file.size / (1024 * 1024) + " mB"
         : file.size / 1024 + " kB";
     let data = {
       caption: "",
       name: file.name,
       size: size,
       type: file.type,
       src: result,
       show: 1,
       isThumbNail: false,
     };
     setUpdateData({
       ...updateData,
       attachment: [...updateData.attachment, data],
     });
   });
 };
 const ratingPop = () => {
   if (allRating !== null) {
     return (
       <div>
         <div style={{ textAlign: 'center', fontSize: '16px' }}>
           <span>Seeker ratings</span>
         </div>
         <div className="mb-2" style={{ fontSize: '14px', textAlign: 'center', display: 'flex' }}>
           <span><Rating readOnly style={{ fontSize: '18px' }} value={allRating.overallRating === null ? 0 : allRating.overallRating} /></span>
           <span style={{ marginTop: '-1px' }}>&nbsp;{allRating.overallRating === null ? 0 : allRating.overallRating} out of 5</span></div>
         <Divider style={{ marginBlock: '2px' }} />
         <div className="mt-2" style={{ fontSize: '14px', textAlign: 'start' }}>{allRating.globalRatings === null ? 0 : allRating.globalRatings} global ratings</div>
         <div className="mt-1" style={{ fontSize: '14px', textAlign: 'start' }}>5 Star <Progress percent={allRating.percentage === null ? 0 : allRating.percentage[5] === undefined ? 0 : allRating.percentage['5']} style={{ width: '100px' }} showInfo={false} /></div>
         <div className="mt-1" style={{ fontSize: '14px', textAlign: 'start' }}>4 Star <Progress percent={allRating.percentage === null ? 0 : allRating.percentage[4] === undefined ? 0 : allRating.percentage['4']} style={{ width: '100px' }} showInfo={false} /></div>
         <div className="mt-1" style={{ fontSize: '14px', textAlign: 'start' }}>3 Star <Progress percent={allRating.percentage === null ? 0 : allRating.percentage[3] === undefined ? 0 : allRating.percentage['3']} style={{ width: '100px' }} showInfo={false} /></div>
         <div className="mt-1" style={{ fontSize: '14px', textAlign: 'start' }}>2 Star <Progress percent={allRating.percentage === null ? 0 : allRating.percentage[2] === undefined ? 0 : allRating.percentage['2']} style={{ width: '100px' }} showInfo={false} /></div>
         <div className="mt-1" style={{ fontSize: '14px', textAlign: 'start' }}>1 Star <Progress percent={allRating.percentage === null ? 0 : allRating.percentage[1] === undefined ? 0 : allRating.percentage['1']} style={{ width: '100px' }} showInfo={false} /></div>
       </div>
     )
   }
 }
 const filterOptions = () => {
   return (
     <div style={{ fontWeight: "300", fontSize: "15px" }}>
       <span
         style={{ cursor: "pointer",color:'#2a364a' }}
         onClick={() => {
           advanceFilterModalToggle({
             bool: true,
             value: "cmtransfersinglemodal",
           });
           cmrSelectedDataDetailed(data);
         }}
       >
         <i className="fa fa-handshake-o" style={{ fontSize: "20px",color:'#2a364a' }}></i>
         &nbsp;Transfer Ownership
       </span>
       <Divider style={{ marginBlock: "5px" }} />
       <span style={{ cursor: "pointer",color:'#2a364a' }} onClick={() => setEdit(true)}>
         <i className="fa fa-pencil-square-o" style={{ fontSize: "20px",color:'#2a364a' }}></i>
         &nbsp;Edit Answer
       </span>
       <Divider style={{ marginBlock: "5px" }} />
       <span
         style={{ cursor: "pointer",color:'#2a364a' }}
         onClick={() => {
           advanceFilterModalToggle({
             bool: true,
             value: "cmdeleteanswermodal",
           });
           cmrSelectedDataDetailed(data);
         }}
       >
         <i className="fa fa-trash" style={{ fontSize: "20px",color:'#2a364a' }}></i>
         &nbsp;Delete Answer
       </span>
     </div>
   );
 };
 const setInlineImage = (str) => {
   let newStr = str;
   if (Object.keys(inline).length === 0) {
     return str;
   } else {
     Object.keys(inline).filter((obj) => {
       newStr = newStr.replace(obj, `<img src=${inline[obj]} />`);
     });
     return newStr;
   }
 };
 const updateCurationStatusFunc = () => {
   setLoad(true);
   let payload = {
     answerUuidStr: data.answerUuid,
     curationStatus: isCurated ? "pending" : "curated",
   };
   let data1 = [];
   data1.push(payload)
   updateCurationStatus(data1).then((res) => {
     if (res === undefined) return;
     if (res.data.success) {
       toast.success(
         () => {
           return <span style={{ fontSize: "12px" }}>{res.data.message}</span>;
         },
         {
           position: toast.POSITION.TOP_RIGHT,
         }
       );
       setCurated(!isCurated);
       setLoad(false);
     }
   });
 };
 const isDisabled = (text) => {
   var regex = /(<([^>]+)>)/gi;
   var result = text.replace(regex, "");
   return result;
 };
 const submitAns = (flag) => {
   setPlay(true)
   let payload = { ...answer };
   let payloadTwo = {
     questionUuid: payload.questionUuid,
     answerUuid: payload.answerUuid,
     answerText: updateData.text,
     expertUUID: payload.expertUuid,
     expertRequestUuid: payload.expertRequestUuid,
     privacy: updateData.privacy,
     expertAnswerRequest: {
       uplodedFiles: updateData.attachment
     },
     internal: updateData.internal,
     notifyUsers: flag,
     makeRecent: isRecent,
     inlineImages: payload.inlineImages
   }
   expertAnswerQuestion(payloadTwo, true).then(res => {
     if (res === undefined) return;
     if (res.data.success) {
       setPlay(false);
       reload('g');
       cmrIsGoBack(false);
       toast.success(
         () => {
           return <span style={{ fontSize: "12px" }}>{res.data.message}</span>;
         },
         {
           position: toast.POSITION.TOP_RIGHT,
         }
       );
       setModal(false);
     }
   });
 };
 useEffect(() => {
   fetchRating();
 }, []);



 // console.log("expertRecordsState",data?.curationCategory)
 //   console.log("attachments",data.attachments)
 return (
   <>
     <Spin spinning={isLoading}>
       <Card className="mb-1">
         <div
           style={{
             display: "flex",
             justifyContent: "space-between",
             alignItems: "baseline",
           }}
         >
           <div>
             <div>
               <Tag
                 color={
                   data.answerStatus === "answered"
                     ? "#008000"
                     : data.answerStatus === "open"
                       ? "#3086ba"
                       : "#987f77"
                 }
                 style={{ fontSize: "14px", textTransform: "capitalize" }}
               >
                 {data.answerStatus}
               </Tag>
               {!data.docId && data.answerStatus === "answered" && <Tag
                 color={'#eb5a2a'}
                 style={{ fontSize: "14px", textTransform: "capitalize" }}
               >
                 Expert Sourced
               </Tag>}
               {data.answeredTimestamp > data.answerUpdatedTimestamp && (
                 <span
                   style={{ color: "#2A364A", fontSize: "13px", fontWeight: "300" }}
                 >
                   on{" "}
                   {moment(data.answeredTimestamp).format(
                     "MMMM DD, YYYY h:mm:ss A"
                   )}
                 </span>
               )}
               {data.answeredTimestamp === data.answerUpdatedTimestamp && (
                 <span
                   style={{ color: "#2A364A", fontSize: "13px", fontWeight: "300" }}
                 >
                   on{" "}
                   {moment(data.answeredTimestamp).format(
                     "MMMM DD, YYYY h:mm:ss A"
                   )}
                 </span>
               )}
               {data.answeredTimestamp < data.answerUpdatedTimestamp && (
                 <span
                   style={{ color: "#2A364A", fontSize: "13px", fontWeight: "300" }}
                 >
                   Last updated on{" "}
                   {moment(data.answerUpdatedTimestamp).format(
                     "MMMM DD, YYYY h:mm:ss A"
                   )}{" "}
                   by{" "}
                   <span
                     style={{
                       fontSize: "13px",
                       color: "#2A364A",
                       fontWeight: "500",
                     }}
                   >
                     {data.lastUpdatedByExpert}
                   </span>
                 </span>
               )}
             </div>
             <div className="mt-1">
               <span style={{ fontSize: "14px", fontWeight: "300", color: "#2A364A", }}>
                 Expert&nbsp;
                 <span
                   style={{
                     fontSize: "13px",
                     color: "#2A364A",
                     fontWeight: "500",
                   }}
                 >
                   {data.expertFirstName} {data.expertLastName}
                 </span>
                 <span
                   style={{
                     color: "#2A364A",
                     fontSize: "12px",
                     fontWeight: "bold",
                   }}
                 >
                   &nbsp;&nbsp;<i className="fa fa-star"></i>&nbsp;
                   {data.expertScore}/10
                 </span>
               </span>
             </div>
           </div>
           <div style={{ display: "flex", }}>
             {/* {isCurated&& expertRecordsState.cs === 'pending' && <span className={styles.viewScore}
                 style={{
                   float: "right",                  
                 }}>
                   <span style={{
                   borderRadius:'3px',
                   backgroundColor:`${answer. === 1 ? 'red':answer.curationCategory === 2 ? 'orange':'green'}`,
                   color:'#fff',
                   fontSize:'10px',
                   padding:'4px',curationCategory
                   fontWeight:'600',
                 }}>
                   Needs Curation - {curationStatus[answer.curationCategory-1]}
                   </span>
             </span>} */}
             {/* <div style={{display:"flex",paddingTop:"2px"}}> */}


             {
               !isCurated && data?.curationCategory !== undefined && <>
                 <Tag
                   color={
                     data?.curationCategory == 1
                       ? "#f01f1f"
                       : data?.curationCategory == 2
                         ? "#ed8607"
                         : data?.curationCategory == 3 ? "#008000" : ""
                   }


                   // color={
                   //  `${data?.curationCategory == 1 ? 'red':data?.curationCategory == 2 ? 'orange':data?.curationCategory == 3?'green':"null"}`
                   // }
                   style={{ fontSize: "14px", textTransform: "capitalize", height: "21.6px", marginTop: "3px" }}
                 >
                   Needs Curation - {`${data?.curationCategory == 1 ? 'High' : data?.curationCategory == 2 ? 'Medium' : data?.curationCategory == 3 ? 'Low' : "null"}`}






                 </Tag>
               </>
             }


             {isLoad && data.answerStatus === "answered" && (
               <SyncOutlined
                 spin
                 style={{
                   fontSize: "18px",
                   color: `${isCurated ? "grey" : "#3aa106"}`,
                 }}
               />
             )}


             {!isLoad && data.answerStatus === "answered" && (
               // <Tooltip placement="top"
               //   color="#fff"
               //   title={() => (
               //     <span style={{ color: "black", fontSize: "11px" }}>
               //       {isCurated ? 'Curated' : 'Need curation'}
               //     </span>
               //   )}>
               //   <span
               //     onClick={() => updateCurationStatusFunc(data)}
               //     style={{ cursor: "pointer" }}
               //   >
               //     {isCurated && (


               //       <>
               //         <svg
               //           width="16px"
               //           color="#3aa106"
               //           height="16px"
               //           viewBox="0 0 16 16"
               //           class="bi bi-bookmark-check-fill"
               //           fill="currentColor"
               //         >
               //           <path
               //             fill-rule="evenodd"
               //             d="M4 0a2 2 0 0 0-2 2v13.5a.5.5 0 0 0 .74.439L8 13.069l5.26 2.87A.5.5 0 0 0 14 15.5V2a2 2 0 0 0-2-2H4zm6.854 5.854a.5.5 0 0 0-.708-.708L7.5 7.793 6.354 6.646a.5.5 0 1 0-.708.708l1.5 1.5a.5.5 0 0 0 .708 0l3-3z"
               //           ></path>
               //         </svg>
               //         {/* <CuratedSync style={{color:"#FF5F1F",border:"none"}}/> */}
               //       </>
               //     )}
               //     {!isCurated && (
               //       <svg
               //         width="16px"
               //         color="grey"
               //         height="16px"
               //         viewBox="0 0 16 16"
               //         class="bi bi-bookmark-check-fill"
               //         fill="currentColor"
               //       >
               //         <path
               //           fill-rule="evenodd"
               //           d="M4 0a2 2 0 0 0-2 2v13.5a.5.5 0 0 0 .74.439L8 13.069l5.26 2.87A.5.5 0 0 0 14 15.5V2a2 2 0 0 0-2-2H4zm6.854 5.854a.5.5 0 0 0-.708-.708L7.5 7.793 6.354 6.646a.5.5 0 1 0-.708.708l1.5 1.5a.5.5 0 0 0 .708 0l3-3z"
               //         ></path>
               //       </svg>
               //     )}
               //   </span>
               // </Tooltip>


               <TooltipComp title={isCurated ? 'Curated' : 'Need curation'}>
                 <span
                   onClick={() => updateCurationStatusFunc(data)}
                   style={{ cursor: "pointer" }}
                 >
                   {isCurated && (


                     <>
                       <svg
                         width="16px"
                         color="#3aa106"
                         height="16px"
                         viewBox="0 0 16 16"
                         class="bi bi-bookmark-check-fill"
                         fill="currentColor"
                       >
                         <path
                           fill-rule="evenodd"
                           d="M4 0a2 2 0 0 0-2 2v13.5a.5.5 0 0 0 .74.439L8 13.069l5.26 2.87A.5.5 0 0 0 14 15.5V2a2 2 0 0 0-2-2H4zm6.854 5.854a.5.5 0 0 0-.708-.708L7.5 7.793 6.354 6.646a.5.5 0 1 0-.708.708l1.5 1.5a.5.5 0 0 0 .708 0l3-3z"
                         ></path>
                       </svg>
                       {/* <CuratedSync style={{color:"#FF5F1F",border:"none"}}/> */}
                     </>
                   )}
                   {!isCurated && (
                     <svg
                       width="16px"
                       color="grey"
                       height="16px"
                       viewBox="0 0 16 16"
                       class="bi bi-bookmark-check-fill"
                       fill="currentColor"
                     >
                       <path
                         fill-rule="evenodd"
                         d="M4 0a2 2 0 0 0-2 2v13.5a.5.5 0 0 0 .74.439L8 13.069l5.26 2.87A.5.5 0 0 0 14 15.5V2a2 2 0 0 0-2-2H4zm6.854 5.854a.5.5 0 0 0-.708-.708L7.5 7.793 6.354 6.646a.5.5 0 1 0-.708.708l1.5 1.5a.5.5 0 0 0 .708 0l3-3z"
                       ></path>
                     </svg>
                   )}
                 </span>
               </TooltipComp>
             )}
             {data.answerStatus === "answered" && (
               <div style={{ fontSize: "18px" }}>
                 <Popover
                   placement={"bottom"}
                   content={filterOptions()}
                   title=""
                   trigger="hover"
                 >
                   <MoreOutlined style={{ cursor: "pointer" }} />
                 </Popover>
               </div>
             )}




             {!state.express && data.answerStatus === "open" && (
               <div
                 style={{
                   fontSize: "22px",
                   color: "#3086ba",
                   cursor: "pointer",
                 }}
               >
                 {/* <Tooltip placement="top"
                   color="#fff"
                   title={() => (
                     <span style={{ color: "black", fontSize: "11px" }}>
                       Expedite from this Expert
                     </span>
                   )}>
                   <i
                     className="fa fa-sign-out"
                     onClick={() => {
                       cmrSelectedDataDetailed(data);
                       advanceFilterModalToggle({
                         bool: true,
                         value: "expeditequestionmodal",
                       });
                     }}
                   ></i>
                 </Tooltip> */}
                 <TooltipComp title={" Expedite from this Expert"}>
                   <i
                     className="fa fa-sign-out"
                     onClick={() => {
                       cmrSelectedDataDetailed(data);
                       advanceFilterModalToggle({
                         bool: true,
                         value: "expeditequestionmodal",
                       });
                     }}
                   ></i>
                 </TooltipComp>
               </div>
             )}
           </div>
         </div>
         {!isEdit && (
           <div>
             {data.answer === undefined ? (
               ""
             ) : (
               <div
                 className="mt-1 p-1"
                 style={{
                   background: "#FAFAFA",
                   border: "1px solid #FAFAFA",
                   borderRadius: "4px",
                   wordWrap: "break-word"
                 }}
                 dangerouslySetInnerHTML={{
                   __html: replaceContentEditableText(
                     data.answer === undefined ? "" : setInlineImage(data.answer)
                   ),
                 }}
               ></div>
             )}
             {data.url !== undefined && data.url !== "" && (
               <div
                 style={{
                   background: "#FAFAFA",
                   border: "1px solid #FAFAFA",
                   borderRadius: "4px",
                 }}
               >
                 <span>
                   URL&nbsp;{" "}
                   {data.url && (
                     <a href={data.url} target="_blank">
                       {data.url}
                     </a>
                   )}
                 </span>
               </div>
             )}
             {data.attachments !== undefined && data.attachments.length > 0 && (
               <div
                 style={{
                   background: "#FAFAFA",
                   border: "1px solid #FAFAFA",
                   borderRadius: "4px",
                 }}
               >
                 {data.attachments !== undefined &&
                   data.attachments.length > 0 &&
                   data.attachments.map((attch) => {
                     return <AttachmentBox attachment={attch} />;
                   })}
               </div>
             )}
             <div style={{ display: "flex", justifyContent: "space-between" }}>
               <div style={{ display: "flex", alignItems: "center" }}>
                 {data.popularityScore && (
                   <>
                     {/* <Tooltip
                       placement="right"
                       color="#fff"
                       title={() => (
                         <span style={{ color: "black", fontSize: "11px" }}>
                           Number of times this answer was viewed.
                         </span>
                       )}>
                       <span style={{ fontSize: "14px", color: "black", cursor: 'pointer' }}>
                         <i className="fa fa-eye"></i>&nbsp;
                         <span style={{ fontSize: "12px" }}>
                           {data.popularityScore}
                         </span>
                       </span>
                     </Tooltip> */}
                     <TooltipComp title={"Number of times this answer was viewed."}>
                       <span
                         style={{
                           display: "flex",
                           alignItems: "center",
                           fontSize: "14px",
                           lineHeight: "24px",
                           color: "#5C667B",
                           fontWeight: "500",
                         }}
                       >
                         <ViewIcon />
                         &nbsp;{data.popularityScore}&nbsp;&nbsp;
                       </span>
                     </TooltipComp>
                   </>
                 )}
                 {data.popularityScore && (
                   <span>
                     &nbsp;
                     {/* <span style={{  color: "lightgrey" }}>|</span> */}
                     &nbsp;
                     <Popover placement={"bottom"}
                       content={ratingPop()}
                       title=""
                       trigger="hover">
                       <span>
                         <Rating
                           readOnly
                           value={rating}
                           style={{ fontSize: "20px", marginTop: '5px' }}
                         />
                       </span>
                     </Popover>
                   </span>
                 )}
                 {/* {data.popularityScore && <span>&nbsp;<span style={{height:'8px', color:'lightgrey'}}>|</span>&nbsp;Make Recent </span>} */}
               </div>
               <div style={{ display: "flex", alignItems: "center" }}>
                 {data.privacy && (
                   <span>
                     <i
                       className="fa fa-lock"
                       style={{ fontSize: "16px", color: "black" }}
                     ></i>
                     <span style={{ fontSize: "12px" }}>
                       &nbsp;Private Answer
                     </span>
                   </span>
                 )}
                 {data.internal && (
                   <span>
                     <i
                       className="fa fa-user-times"
                       style={{ fontSize: "16px", color: "black" }}
                     ></i>
                     <span style={{ fontSize: "12px" }}>
                       &nbsp;Internal Only
                     </span>
                   </span>
                 )}
               </div>
             </div>
           </div>
         )}
         {isEdit && (
           <div>
             <input
               type="file"
               id="actual-btn3"
               onChange={(e) => attachmentsData(e.target.files[0])}
               style={{ display: "none" }}
               name="files"
               required=""
               maxsize="500"
               aria-invalid="true"
             ></input>
             <label for="actual-btn3">
               <i
                 className="fa fa-paperclip"
                 style={{
                   position: "absolute",
                   left: "325px",
                   marginTop: "20px",
                   color: "#434343",
                   fontSize: "16px",
                   fontWeight: "bold",
                   cursor: "pointer",
                 }}
               ></i>
             </label>
             <ReactQuill
               theme="snow"
               value={updateData.text}
               modules={modules}
               formats={formats}
               onChange={(e) => setUpdateData({ ...updateData, text: e })}
               height="200px"
             />
             <div
               style={{ display: "flex", paddingBlock: "5px", marginTop: "0px" }}
             >
               <div style={{ width: "40%", textAlign: "start" }}>
                 <Popover placement={"bottom"}
                   content={ratingPop()}
                   title=""
                   trigger="hover">
                   <span>
                     <Rating
                       readOnly
                       value={rating}
                       style={{ fontSize: "20px", marginTop: '5px' }}
                     />
                   </span>
                 </Popover>
               </div>
               <div
                 style={{
                   width: "60%",
                   display: "flex",
                   justifyContent: "end",
                   alignItems: "center",
                 }}
               >
                 <span
                   style={{
                     fontSize: "14px",
                     display: "flex",
                     fontWeight: "400",
                     alignItems: "center",
                   }}
                 >


                   <Checkbox
                     type="checkbox"
                     style={{paddingRight:"2px"}}
                     checked={isRecent}
                     onChange={(e) =>
                       setRecent(e.target.checked)
                     } /> &nbsp;<i className="fa fa-history"></i>&nbsp;Make Recent&nbsp;
                   <TooltipComp title=" This QA pair will be visible on top." >
                     <i className='fa fa-question-circle tooltip-topics-b' ></i>
                   </TooltipComp>
                 </span>
                 &nbsp;&nbsp;
                 <span
                   style={{
                     fontSize: "14px",
                     display: "flex",
                     fontWeight: "400",
                     alignItems: "center",
                     paddingLeft: "3px"
                   }}
                 >
                   <Checkbox type="checkbox"
                     checked={updateData.internal}
                     onChange={(e) =>
                       setUpdateData({
                         ...updateData,
                         internal: e.target.checked,
                       })
                     } />&nbsp;
                   <img src={InternalIcon} width="18" />&nbsp;Internal Only&nbsp;
                   {/* <span style={textStyles}>
                 Internal Only
             </span> */}
                   {/* <Internal/> */}
                   <TooltipComp title="This QA pair will be visible only to Employees and not to Customers & Partners." >
                     <i className='fa fa-question-circle tooltip-topics-b' ></i>
                   </TooltipComp>
                 </span>
                 &nbsp;&nbsp;
                 <span
                   style={{
                     fontSize: "14px",
                     display: "flex",
                     fontWeight: "400",
                     alignItems: "center"
                   }}
                 >
                   <Checkbox type="checkbox"
                     checked={updateData.privacy}
                     onChange={(e) =>
                       setUpdateData({
                         ...updateData,
                         privacy: e.target.checked,
                       })
                     } />&nbsp;
                   <i className="fa fa-lock"></i>&nbsp;Private Answer&nbsp;
                   <TooltipComp title='This answer will be visible only to the Seeker who asked the question, and to all Experts.'>
                     <i className='fa fa-question-circle tooltip-topics-b'></i>
                   </TooltipComp>
                 </span>
               </div>


             </div>


             <div style={{ display: "flex" }}>
               <div style={{ textAlign: "start", width: '60%' }}>
                 {updateData.attachment.length > 0 &&
                   updateData.attachment.map((obj) => {
                     return (
                       <Tag
                         closeIcon={<CloseCircleOutlined />}
                         closable
                         onClose={(e) => {
                           e.preventDefault();
                           setUpdateData({
                             ...updateData,
                             attachment: updateData.attachment.filter((ob) => {
                               return obj.name !== ob.name;
                             }),
                           });
                         }}
                       >
                         {obj.name}
                       </Tag>
                     );
                   })}
               </div>
               <div style={{ textAlign: "end", width: '40%' }}>
                 <button
                   style={{
                     padding: '8px 12px 8px 12px',
                     borderRadius: '6px',
                     fontSize: '14px',
                     lineHeight: '24px',
                     fontWeight: 400,
                     boxShadow: ' 0px 1px 2px 0px #1018280D',
                     color: '#2A364A',
                     border: '1px solid  #fff',
                     height: '40px',
                     minWidth: '88px',
                     background: " #F6F7F8",
                     marginBottom: '14px',
                     fontWeight: 400,
                     border: " 1px solid #E0E2E6"


                     //  font-weight: 400;    
                   }}
                   onClick={() => setEdit(false)}
                 >
                   Cancel
                 </button>
                 &nbsp;&nbsp;
                 <button
                   style={{
                     padding: '8px 12px 8px 12px',
                     borderRadius: '6px',
                     fontSize: '14px',
                     lineHeight: '24px',
                     fontWeight: 400,
                     boxShadow: '0px 1px 2px 0px #1018280D',
                     color: '#FFFFFF',
                     border: '1px solid  #fff',
                     height: '40px',
                     minWidth: '88px',
                     background: 'linear-gradient(90.39deg, #00D1FF 0.34%, #0075FF 99.7%)',
                     marginBottom: '14px',
                     cursor: isDisabled(updateData.text) === "" ? "not-allowed" : "pointer",
                     opacity: `${isDisabled(updateData.text) === "" ? ".7" : "1"}`
                   }}
                   onClick={() => setModal(true)}
                   disabled={isDisabled(updateData.text) === "" ? true : false}
                 >
                   Submit
                 </button>
               </div>
             </div>
           </div>
         )}
       </Card>
     </Spin>
     <Modal
       show={isModal}
       size={"md"}
       centered={true}
       onHide={() => setModal(false)}
       backdrop="static"
     >
       <Modal.Header closeButton>
         <Modal.Title style={modalTitleStyle}>


           {/* <span className="fa fa-user-circle"></span> */}
           {/* &nbsp;&nbsp;   Do you want to notify the involved users about your change? */}
         </Modal.Title>
       </Modal.Header>
       <Modal.Body style={{ paddingBottom: "0px", textAlign: 'center' }}>
         <div >
           {/* <span style={{ color: "black", fontSize: "14px" }}>
             Do you want to notify the involved users about your change?
           </span> */}
           <p style={{ fontSize: "18px" }}>
             Do you want to notify the involved users about your change?
           </p>


           <div className="mt-2 mb-2" style={{ texAlign: "center" }}>
             {!isPlay && <><button className="cancelBtn"
               style={{
                 padding: '8px 12px 8px 12px',
                 borderRadius: '6px',
                 fontSize: '14px',
                 lineHeight: '24px',
                 fontWeight: 400,
                 boxShadow: ' 0px 1px 2px 0px #1018280D',
                 color: '#2A364A',
                 border: '1px solid  #fff',
                 height: '40px',
                 minWidth: '88px',
                 background: " #F6F7F8",
                 marginBottom: '14px',
                 fontWeight: 400,
                 border: " 1px solid #E0E2E6"


                 //  font-weight: 400;    
               }}
               onClick={() => submitAns(false)}>No</button>&nbsp;<button className="rerouteBtn"
                 style={{
                   padding: '8px 12px 8px 12px',
                   borderRadius: '6px',
                   fontSize: '14px',
                   lineHeight: '24px',
                   fontWeight: 400,
                   boxShadow: '0px 1px 2px 0px #1018280D',
                   color: '#FFFFFF',
                   border: '1px solid  #fff',
                   height: '40px',
                   minWidth: '88px',
                   background: 'linear-gradient(90.39deg, #00D1FF 0.34%, #0075FF 99.7%)',
                   marginBottom: '14px',
                   marginTop: "15px",
                   cursor: "pointer"
                 }}
                 onClick={() => submitAns(true)}>Yes</button></>}
             {isPlay && <button className="loadingpublishbutton"
               style={{
                 padding: '8px 12px 8px 12px',
                 borderRadius: '6px',
                 fontSize: '14px',
                 lineHeight: '24px',
                 fontWeight: 400,
                 boxShadow: '0px 1px 2px 0px #1018280D',
                 color: '#FFFFFF',
                 border: '1px solid  #fff',
                 height: '40px',
                 minWidth: '88px',
                 background: 'linear-gradient(90.39deg, #00D1FF 0.34%, #0075FF 99.7%)',
                 marginBottom: '14px',
                 marginTop: "15px",
                 cursor: "not-allowed",
                 opacity:"0.7"
               }}
               disabled><i className="fa fa-spinner"></i>&nbsp;&nbsp;Updating...</button>}
           </div>
         </div>
       </Modal.Body>
     </Modal>
   </>
 );
}
